<script>
export default {
  name: "warning-icon",
};
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.7264 17.0865H16.2764C17.5597 17.0865 18.3597 15.6948 17.7181 14.5865L11.4431 3.74482C10.8014 2.63649 9.2014 2.63649 8.55974 3.74482L2.28474 14.5865C1.64307 15.6948 2.44307 17.0865 3.7264 17.0865ZM10.0014 11.2532C9.54307 11.2532 9.16807 10.8782 9.16807 10.4198V8.75316C9.16807 8.29482 9.54307 7.91982 10.0014 7.91982C10.4597 7.91982 10.8347 8.29482 10.8347 8.75316V10.4198C10.8347 10.8782 10.4597 11.2532 10.0014 11.2532ZM10.8347 14.5865H9.16807V12.9198H10.8347V14.5865Z"
      fill="white"
    />
  </svg>
</template>

<style scoped></style>
